// The device's clock. The browser knows which zone it is in; Substance is
// told in a cookie, so that dates and times on the page can be read in it
// when a member has not chosen a zone of their own in settings. Nothing is
// sent anywhere else, and it is rewritten quietly when the device travels.
function tellTheZone() {
  let zone
  try {
    zone = Intl.DateTimeFormat().resolvedOptions().timeZone
  } catch {
    return
  }
  if (!zone || !/^[A-Za-z0-9_+\-/]+$/.test(zone)) return

  const current = document.cookie.split("; ").find((c) => c.startsWith("tz="))?.slice(3)
  if (decodeURIComponent(current ?? "") === zone) return

  const secure = location.protocol === "https:" ? "; Secure" : ""
  document.cookie = `tz=${encodeURIComponent(zone)}; Path=/; Max-Age=31536000; SameSite=Lax${secure}`
}

tellTheZone()
